import WbBagsLabel from '@features/WbBagsLabel/ui/WbBagsLabel';

export default function WbBagsLabelPage() {
  return <WbBagsLabel />;
}
